import { SHORTCUT_CATALOG } from "./shortcutCatalog.js";

/**
 * Chord → command id for the global keydown handler.
 * Later entries in the catalog win on duplicate chords (should not happen after mapper validation).
 */
export function buildChordToCommandMap(
  overrides: Readonly<Partial<Record<string, string>>> | undefined,
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const row of SHORTCUT_CATALOG) {
    const raw = overrides?.[row.commandId];
    const chord = (raw !== undefined && raw.trim() !== "" ? raw.trim() : row.defaultChord).trim();
    if (chord) out[chord] = row.commandId;
  }
  return out;
}

/** True if no other catalog command uses this chord for the given effective map (excluding `exceptCommandId`). */
export function isChordAvailable(
  chord: string,
  overrides: Readonly<Partial<Record<string, string>>>,
  exceptCommandId: string,
): boolean {
  const c = chord.trim();
  if (!c) return false;
  for (const row of SHORTCUT_CATALOG) {
    if (row.commandId === exceptCommandId) continue;
    const eff = (overrides[row.commandId] ?? row.defaultChord).trim();
    if (eff === c) return false;
  }
  return true;
}
